import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import { EnhancedLink } from '@ui/enhanced-components/enhanced-components'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import { clsx } from 'clsx/lite'
import React from 'react'

export const hyperlinkAmplification: NodeRenderer = (node, children) => (
  <EnhancedLink
    className={clsx('!underline group-[.is-dark]/theme:text-white-50')}
    data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
    href={node.data.uri}
  >
    {children}
  </EnhancedLink>
)
